import { ChangeDetectionStrategy, Component, input } from "@angular/core";

/**
 * Inline SVG icon set — reproduces the design bundle's `icons.jsx`.
 * 1.5px stroke, currentColor, sizable. Replaces Angular Material `<mat-icon>`.
 *
 * Usage: <app-icon name="search" [size]="16" />
 */
export type IconName =
  | "search" | "plus" | "filter" | "more" | "chevron-down" | "chevron-right"
  | "chevron-left" | "x" | "check" | "arrow-right" | "edit" | "trash" | "restore"
  | "users" | "user" | "building" | "home" | "workflow" | "clock" | "bell"
  | "settings" | "shield" | "download" | "upload" | "grid" | "mail" | "phone"
  | "sort" | "star" | "link" | "calendar" | "logout" | "clipboard" | "briefcase"
  | "activity" | "file-text" | "key" | "eye" | "eye-off" | "copy";

@Component({
  selector: "app-icon",
  standalone: true,
  templateUrl: "./icon.component.html",
  styleUrl: "./icon.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {

  public readonly name = input.required<IconName>();

  public readonly size = input<number>(16);

  public readonly stroke = input<number>(1.5);
}
